export default {
  name: 'SectionHeading',
  template: `
<div class="section-heading">
  <div class="grid no-row-gap">
    <div class="col-12 col-xs-10 col-sm-8 col-md-7 col-lg-6 col-xl-5 offset-xl-1 col-xxl-4 offset-xxl-2 section-heading__left">
      <h2 class="h1">{{ title }}</h2>
      <hr v-if="subtitle">
      <p v-if="subtitle" class="large-text">{{ subtitle }}</p>
    </div>

    <div v-if="button" class="col-12 col-md-5 col-lg-6 section-heading__right" :class="rightClass">
      <router-link class="arrow-button" :to="button.href">
        <span>{{ button.text }}</span>
        <i class="icon-arrow-right"></i>
      </router-link>
    </div>
  </div>
</div>
  `,
  props: {
    title: String,
    subtitle: String,
    button: Object,
    rightClass: String,
  },
}
